export default "/images/calibration-plus-sign-icon.svg";